import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import type { CardSizePreset } from '../../types/dashboard.types';

interface CardSizeSelectorProps {
  value: CardSizePreset;
  onChange: (preset: CardSizePreset) => void;
}

const SIZE_OPTIONS: Array<{ value: CardSizePreset; label: string }> = [
  { value: 'small', label: 'Small' },
  { value: 'medium', label: 'Medium' },
  { value: 'large', label: 'Large' },
  { value: 'wide', label: 'Wide' },
];

export function CardSizeSelector({ value, onChange }: CardSizeSelectorProps) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="h-8 w-24">
        <SelectValue placeholder="Size" />
      </SelectTrigger>
      <SelectContent>
        {SIZE_OPTIONS.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
